export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_CURRENT_MISSION = 'SET_CURRENT_MISSION'
export const SET_CURRENT_RESULTS = 'SET_CURRENT_RESULTS'
export const UPDATE_WATERFALL_CHILD_DATA_CACHE =
  'UPDATE_WATERFALL_CHILD_DATA_CACHE'
export const UPDATE_FORM_DATA_CACHE = 'UPDATE_FORM_DATA_CACHE'
export const UPDATE_EDITED_COMPONENT_NAME = 'UPDATE_EDITED_COMPONENT_NAME'
export const LOAD_MISSIONS = 'LOAD_MISSIONS'
export const UPDATE_USER_SETTINGS = 'UPDATE_USER_SETTINGS'
export const UPDATE_DEFAULT_SETTINGS = 'UPDATE_DEFAULT_SETTINGS'
export const UPDATE_OPTIONS = 'UPDATE_OPTIONS'
export const UPDATE_COMPARED_EVASIVE_MANEUVERS =
  'UPDATE_COMPARED_EVASIVE_MANEUVERS'
export const UPDATE_CUSTOM_EVASIVE_SCENARIOS = 'UPDATE_CUSTOM_EVASIVE_SCENARIOS'
export const UPDATE_CUSTOM_EVASIVE_REPORTS = 'UPDATE_CUSTOM_EVASIVE_REPORTS'
export const UPDATE_CUSTOM_EVASIVE_LOADING = 'UPDATE_CUSTOM_EVASIVE_LOADING'
export const UPDATE_CUSTOM_EVASIVE_ERRORS = 'UPDATE_CUSTOM_EVASIVE_ERRORS'
export const SET_COMPARED_EVASIVE_MANEUVERS = 'SET_COMPARED_EVASIVE_MANEUVERS'
export const SET_DISPLAYED_SCREENING_EVENT = 'SET_DISPLAYED_SCREENING_EVENT'
export const SET_DISPLAYED_SCREENING_TAB = 'SET_DISPLAYED_SCREENING_TAB'
export const SET_SCREENING_ALERTS = 'SET_SCREENING_ALERTS'
